import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';

interface UserCountryContextType {
  userCountry: string;
}
const allowedCountry = ['au', 'ca', 'us']
export const getUserCountry = async (): Promise<string> => {
  try {
    const response = await fetch('https://ipinfo.io/json');
    const data = await response.json();
    const countryCode = data.country?.toLowerCase() || 'us';
    if (allowedCountry.includes(countryCode)) {
      return countryCode;
    }

    return 'us';
  } catch (error) {
    console.error('Failed to fetch country from ipinfo', error);
    return 'us';
  }
};

const UserCountryContext = createContext<UserCountryContextType | undefined>(
  undefined,
);

export const UserCountryProvider = ({ children }: { children: ReactNode }) => {
  const [userCountry, setUserCountry] = useState('us');

  useEffect(() => {
    const fetchAndSetCountry = async () => {
      const country = await getUserCountry();
      setUserCountry(country);
    };
    fetchAndSetCountry();
  }, []);

  return (
    <UserCountryContext.Provider value={{ userCountry }}>
      {children}
    </UserCountryContext.Provider>
  );
};

export const useUserCountry = (): UserCountryContextType => {
  const context = useContext(UserCountryContext);
  if (!context) {
    throw new Error('useUserCountry must be used within a UserCountryProvider');
  }
  return context;
};
